"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiGatewayHeaders = exports.getHost = exports.getEsspHeaders = exports.getCredentials = exports.essPortalUrl = exports.apiGatewayUrl = exports.Stage = exports.AtoZClientId = void 0;
var AtoZClientId;
(function (AtoZClientId) {
    AtoZClientId["TIME_OFF"] = "ATOZ_TIMEOFF_SERVICE";
    AtoZClientId["PAY_BREAKDOWN"] = "ATOZ_PAY_BREAKDOWN";
    AtoZClientId["MY_HR_GATEWAY"] = "ATOZ_MYHRGATEWAY_SERVICE";
})(AtoZClientId = exports.AtoZClientId || (exports.AtoZClientId = {}));
var Stage;
(function (Stage) {
    Stage["DEVELOPMENT"] = "development";
    Stage["DEV"] = "dev";
    Stage["TEST"] = "test";
    Stage["ESSP"] = "essp";
    Stage["BETA"] = "beta";
    Stage["GAMMA"] = "gamma";
    Stage["PROD"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
exports.apiGatewayUrl = {
    development: 'http://localhost:8080',
    dev: 'http://0.0.0.0:4000',
    test: 'https://atoz-api.integ.amazon.com',
    essp: 'https://atoz-api.integ.amazon.com',
    beta: 'https://atoz-api.integ.amazon.com',
    gamma: 'https://atoz-api.integ.amazon.com',
    prod: 'https://atoz-api.amazon.work'
};
exports.essPortalUrl = {
    development: 'http://localhost:8080',
    dev: 'http://0.0.0.0:4000',
    test: 'https://essportal.integ.amazon.com',
    essp: 'https://essportal.integ.amazon.com',
    beta: 'https://essportal.integ.amazon.com',
    gamma: 'https://essportal.integ.amazon.com',
    prod: 'https://atoz.amazon.work'
};
const getCredentials = (stage) => {
    if (stage === Stage.DEV) {
        return 'same-origin';
    }
    return 'include';
};
exports.getCredentials = getCredentials;
const getEsspHeaders = () => {
    const csrfTokenElement = document.querySelector('meta[name=csrf-token]');
    return {
        Accept: 'text/javascript',
        'X-CSRF-Token': (csrfTokenElement && csrfTokenElement.content) || '',
        'Content-Type': 'application/json'
    };
};
exports.getEsspHeaders = getEsspHeaders;
const getHost = (currentStage) => exports.apiGatewayUrl[currentStage] || exports.apiGatewayUrl[Stage.BETA];
exports.getHost = getHost;
var getApiGatewayHeaders_1 = require("./getApiGatewayHeaders");
Object.defineProperty(exports, "getApiGatewayHeaders", { enumerable: true, get: function () { return getApiGatewayHeaders_1.getApiGatewayHeaders; } });
